import { useState } from "react";
import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import {
  verveContactService
} from "@/services/VerveContactService";
import { useTelecallers } from "./useTelecallers";
import { useOfficeLocations } from "./useOfficeLocations";
import { showSuccessMessage, showApiError } from "@/lib/toast";

export const useAllocationData = ({ onSuccess } = {}) => {
  const queryClient = useQueryClient();
  const [allocations, setAllocations] = useState([{ userId: "", count: "", location: "", officeLocation: "" }]);

  const { telecallers, loading: telecallersLoading } = useTelecallers();
  const { locations: officeLocations, isLoading: officesLoading } = useOfficeLocations();

  // Queries
  const statsQuery = useQuery({
    queryKey: ["unassigned-city-stats"],
    queryFn: verveContactService.getUnassignedCityStats
  });

  // Mutation for assignment
  const assignMutation = useMutation({
    mutationFn: async () => {
      const validAllocations = allocations.filter(a => a.userId && parseInt(a.count) > 0);
      if (validAllocations.length === 0) return;
      return await verveContactService.allocateContacts(validAllocations);
    },
    onSuccess: () => {
      showSuccessMessage("Bulk allocation successful!");
      queryClient.invalidateQueries({ queryKey: ["Verve-contacts"] });
      queryClient.invalidateQueries({ queryKey: ["unassigned-city-stats"] });
      setAllocations([{ userId: "", count: "", location: "", officeLocation: "" }]);
      if (onSuccess) onSuccess();
    },
    onError: (error) => showApiError(error)
  });

  return {
    unassignedCityStats: statsQuery.data || { total: 0, cities: [] },
    telecallers,
    officeLocations,
    allocations,
    setAllocations,
    loading: statsQuery.isLoading || telecallersLoading || officesLoading || assignMutation.isPending,
    handleFinalAssign: assignMutation.mutate,
    refetch: statsQuery.refetch
  };
};
